import styles from "./style.module.scss";
import { GQLOffers } from "@gql/types/gql";
import OfferLinks from "@components/shared/offerLinks";
import { PLACE_HOLDER_IMAGE_PATH } from "@lib/sharedUtils";

export default function VendorOffer({
    buyer,
    categoryId,
    vendorShow,
}: {
    buyer: GQLOffers;
    categoryId: number;
    vendorShow?: boolean;
}) {
    return (
        <>
            <div
                className={`${styles["backGroundColor"]} mt-10 flex flex-col sm:flex-row justify-between items-center py-3 sm:px-4 px-6 rounded-lg`}
            >
                <span className={`relative block ${styles["topBuyerImage"]} `}>
                    {buyer.logo?.fullPath ? (
                        <img
                            src={buyer.logo?.fullPath}
                            alt="logo"
                            width={150}
                            height={40}
                        />
                    ) : (
                        <>
                            <img
                                src={PLACE_HOLDER_IMAGE_PATH}
                                alt="logo"
                                width={150}
                                height={40}
                            />
                        </>
                    )}
                </span>
                <div className="  sm:w-[29%] w-full  mt-2 sm:mt-0">
                    <OfferLinks
                        vendor={buyer}
                        categoryId={categoryId}
                        classNameButton={styles["linkButtonStyle"]}
                        vendorShow={vendorShow}
                    />
                </div>
            </div>
        </>
    );
}
